/**
 * Utilities for detecting user intents from search queries
 */

import { INTENT_PATTERNS, DEFAULTS } from './constants';

export interface DetectedIntents {
  isModification: boolean;
}

/**
 * Detects user intents from search text.
 * Only MODIFICATION (substitutions not allowed) is detected here; other intents are managed by WSS.
 */
export const detectIntents = (searchText: string): DetectedIntents => ({
  isModification: INTENT_PATTERNS.MODIFICATION.test(searchText),
});

/**
 * Determines substitution modification from search text
 */
export const getSubstitutionModification = (searchText: string): string => {
  return /substitutions not allowed/i.test(searchText)
    ? DEFAULTS.SUBSTITUTIONS_NOT_ALLOWED
    : DEFAULTS.SUBSTITUTIONS;
};

